import Navigation from "./Navigation";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import Seo from "./Seo";

const InsightLayout = ({
  title,
  subtitle,
  // Eigene Kurzfassung fuer <meta description>/og/twitter, ~150-160 Zeichen.
  // Ohne sie faellt die Description auf den Vorspann zurueck - der ist 300-570
  // Zeichen lang und wird in der Ergebnisliste abgeschnitten.
  metaDescription,
  publishedDate,
  updatedDate,
  readingTime,
  category,
  schemaImage,
  children,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description: subtitle,
    image: schemaImage || "https://daaniyalkhan.com/portrait.webp",
    datePublished: publishedDate,
    dateModified: updatedDate || publishedDate,
    author: {
      "@type": "Person",
      name: "Daaniyal Khan",
      url: "https://daaniyalkhan.com",
      jobTitle: "Strategie- und KI-Berater",
    },
    publisher: {
      "@type": "Organization",
      name: "Daaniyal Khan Consulting",
      logo: {
        "@type": "ImageObject",
        url: "https://daaniyalkhan.com/favicon.svg",
      },
    },
    articleSection: category,
  };

  return (
    <div className="min-h-screen bg-white">
      <Seo
        title={`${title} – Daaniyal Khan`}
        description={metaDescription || subtitle}
        ogType="article"
      />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-[#C5A66A] focus:text-[#0F1B2D] focus:px-4 focus:py-2 focus:rounded focus:font-semibold"
      >
        Zum Hauptinhalt springen
      </a>
      <Navigation />
      <main id="main-content" className="pt-32 pb-20">
        <article className="container mx-auto px-6 max-w-3xl">
          <header className="mb-12">
            <div className="flex items-center gap-3 text-sm text-[#C5A66A] uppercase tracking-wider font-semibold mb-4">
              <Link to="/insights" className="hover:underline">
                Insights
              </Link>
              <span>·</span>
              <span>{category}</span>
              <span>·</span>
              <span>{readingTime}</span>
              {updatedDate && (
                <>
                  <span>·</span>
                  <span>
                    Aktualisiert{" "}
                    {new Date(updatedDate).toLocaleDateString("de-DE", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </span>
                </>
              )}
            </div>
            <h1 className="font-playfair text-4xl lg:text-5xl font-bold text-[#0F1B2D] mb-6 leading-tight">
              {title}
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              {subtitle}
            </p>
            <div className="flex items-center gap-4 pt-6 border-t border-gray-200">
              <img
                src="/portrait.webp"
                alt="Daaniyal Khan"
                className="w-12 h-12 rounded-full object-cover object-[center_5%]"
              />
              <div>
                <div className="font-semibold text-[#0F1B2D]">
                  Daaniyal Khan
                </div>
                <div className="text-sm text-gray-600">
                  Strategie- und KI-Berater · DACH
                </div>
                <div className="text-sm text-gray-600 mt-1">
                  Redaktionell geprüft und verantwortet ·{" "}
                  <a
                    href="/redaktion"
                    className="text-[#C5A66A] underline hover:no-underline"
                  >
                    Redaktion, Quellen und KI-Einsatz
                  </a>
                </div>
              </div>
            </div>
          </header>

          <div className="prose prose-lg max-w-none text-gray-800 leading-relaxed insight-content">
            {children}
          </div>

          <footer className="mt-16 pt-8 border-t border-gray-200">
            <div className="bg-gradient-to-r from-[#0F1B2D] to-[#1a2d4a] rounded-2xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-4 text-[#C5A66A]">
                Strategie-Gespräch buchen
              </h2>
              <p className="text-lg mb-6">
                Konkrete Anwendung dieser Erkenntnisse auf Ihr Unternehmen? Ein
                90-Minuten-Gespräch klärt, wo der größte Hebel liegt.
              </p>
              <Link
                to="/#contact"
                className="inline-block bg-[#C5A66A] text-[#0F1B2D] px-8 py-3 rounded-lg font-semibold hover:bg-[#b8966b] hover:scale-105 transition-all duration-300"
              >
                Kostenloses Erstgespräch
              </Link>
            </div>

            <div className="mt-8 text-center">
              <Link
                to="/insights"
                className="text-[#C5A66A] hover:underline font-semibold"
              >
                ← Alle Insights
              </Link>
            </div>
          </footer>
        </article>
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
    </div>
  );
};

export default InsightLayout;
